import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from 'moment';
import { Environment } from '../../../shared/environment';
import { IgetImpressaoNota } from '../../../shared/services/api/vendas/pedidonota/PedidoNota';

async function PDFPedidoClaudia(dados: IgetImpressaoNota) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl = Environment.URL_IMGFABRICA + dados.logo || '';
  // const imageUrl = '/logo.png';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const TProdutos = dados.itens.reduce((acc, item) => acc + (item.quantidade || 0), 0);
  const Ttotal = dados.itens.reduce((acc, item) => acc + (item.total || 0), 0);
  const TRegistros = dados.itens.length;

  const rows = dados.itens.map((row) => {
    return [
      { text: row.codfabrica, fontSize: 8, },
      { text: row.descricao, fontSize: 8, },
      { text: row.un },
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.quantidade),
        alignment: 'right',  bold: true, fontSize: 9
      },
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.preco),
        alignment: 'right', bold: true, fontSize: 9
      },
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.total),
        alignment: 'right',  bold: true, fontSize: 9
      },
    ]
    
  });

  const documentDefinition: any = {

    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],
          widths: [90, 420],
          body: [
            [
              {
                margin: [0, 5, 0, 0],
                image: imageData,
                width: 90,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: [350],
                  body: [
                    [
                      { text: 'A.D.E SEMI-JOIAS LTDA', fontSize: 12, bold: true, alignment: 'center',
                         border: [false, false, false, false] },
                    ],
                    [
                      { text: 'AVENIDA DOUTOR PEDRO GARCIA MORENO, 1405 - SALAO Q. B L. 16 E 17 - SERRANO', alignment: 'center', border: [false, false, false, false], fontSize: 9, },
                     ],
                    [
                      { text: 'CEP 49503108 - ITABAIANA - SE / CNPJ: 18.382.189/0001-90 I.E: 271414693', alignment: 'center', 
                        fontSize: 9, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Fone/Fax: (79) 3431-2491', alignment: 'center', fontSize: 9, 
                        border: [false, false, false, false] },
                    ],
                  ],

                }
              }
            ],
          ]
        }
      },
      {
        border: [false, false, false, false],  
        table: {
          widths: [200, 50, 60, 60, 75],
          body: [
            [
              { text: 'Proposta Nr.: '+dados.numero+' / O.S.:'+dados.numero, fontSize: 10, bold: true, alignment: 'left', border: [false, false, false, false] },
              { text: 'Emissão', bold: true, border: [false, false, false, false] },
              { text: moment(dados.dataoperacao).format('DD/MM/YYYY'), alignment: 'center', fontSize: 10,  border: [false, false, false, false] },
              { text: 'Entrega:', alignment: 'right', bold: true, border: [false, false, false, false] },
              { text: '**Entreque**',  alignment: 'left', fontSize: 10, border: [false, false, false, false] },
            ],
          ],
        }  
      },
      {
        table: {
          widths: [250, 260],
          body: [
            [   
              { text: 'Razão Social', fontSize: 8, bold: true, border: [true, true, false, false] },
              { text: 'Nome Fantasia', fontSize: 8, border: [false, true, true, false] },
            ],
            [
              { text: dados.nome, fontSize: 9, border: [true, false, false, true] },
              { text: dados.fantasia, fontSize: 9, border: [false, false, true, true] },
            ]
          ],
        }
      },    
      {
        table: {
          widths: [150, 90, 261], 
          body: [
            [   
              { text: 'CPF/CNPJ:', fontSize: 8, bold: true, border: [true, false, false, false] },
              { text: 'RG/I.E:', fontSize: 8, border: [false, false, false, false] },
              { text: 'Endereço:', fontSize: 8, border: [false, false, true, false] },
            ],
            [
              { text: dados.cpf, fontSize: 9, border: [true, false, false, true] },
              { text: dados.rg, fontSize: 9, border: [false, false, false, true] },
              { text: dados.endereco, fontSize: 9, border: [false, false, true, true] },
            ]
          ],
        }
      }, 
      {
        table: {
          widths: [150, 160, 60, 122], 
          body: [
            [   
              { text: 'Bairro:', fontSize: 8, bold: true, border: [true, false, false, false] },
              { text: 'Cidade - UF:', fontSize: 8, border: [false, false, false, false] },
              { text: 'CEP:', fontSize: 8, border: [false, false, false, false] },
              { text: 'Telefone:', fontSize: 8, border: [false, false, true, false] },
            ],
            [
              { text: dados.bairro, fontSize: 9, border: [true, false, false, true] },
              { text: dados.municipio+'-'+dados.uf, fontSize: 9, border: [false, false, false, true] },
              { text: dados.cep, fontSize: 9, border: [false, false, false, true] },
              { text: dados.celular, fontSize: 9, border: [false, false, true, true] },
            ]
          ],
        }
      }, 
      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [50, 200, 30, 54, 70, 70],
          body: [
            [
              { text: 'codigo',  fontSize: 9 },
              { text: 'Descrião', fontSize: 9 },
              { text: 'Unid', alignment: 'center',  fontSize: 9 },
              { text: 'QTD', alignment: 'center',  fontSize: 9 },
              { text: 'VL. Unit', alignment: 'right',  fontSize: 9 },
              { text: 'VL Total', alignment: 'right', fontSize: 9 },
            ],
            ...rows,
          ]
        },
      },
      { text: 'Total da Venda:                                 '+Ttotal, fontSize: 9, bold: true, alignment: 'right', border: [false, true, false, false] },
      { text: 'Itens /   '+TRegistros+'  Unidades: '+TProdutos, border: [false, true, false, false], fontSize: 9 },
      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [520],
          body: [
            [
              { text: 'Condições da Venda 3 - A VISTA', bold: true,  fontSize: 11 },
            ],
          ],
        },   
        layout: {
          vLineStyle: function () {
            return {dash: {length: 5, space: 2}};
          },
          hLineStyle: function () {
            return {dash: {length: 10, space: 3}};
          },
        }  
      },
      { text: 'Desdobramento das Duplicatas', margin: [0, 2, 0, 5],  alignment: 'center', bold: true, border: [true, true, true, true], fontSize: 7},
      {
        table: {
          widths: [40, 60, 57, 60, 60, 60, 60, 60],
          body: [
            [
              { text: 'Nº Lanç.', margin: [0, 5, 0, 0], fontSize: 9 },
              { text: 'Duplicatas', margin: [0, 5, 0, 0],  alignment: 'center', fontSize: 9 },
              { text: 'Emissão', margin: [0, 5, 0, 0], alignment: 'center', fontSize: 9 },
              { text: 'Vencimento', margin: [0, 5, 0, 0],  alignment: 'center', fontSize: 9 },
              { text: 'VL.\nDuplicatas', alignment: 'center', fontSize: 9 },
              { text: 'Saldo a Pagar', margin: [0, 5, 0, 0], alignment: 'center', fontSize: 9 },
              { text: 'Condição', margin: [0, 5, 0, 0], alignment: 'center', fontSize: 9 },
              { text: 'Forma Pagto', margin: [0, 5, 0, 0], alignment: 'center', fontSize: 9 },
            ],
          ],
        },     
      },
      {
        margin: [0, 5, 0, 5],
        table: {
          widths: [520],
          body: [
            [
              { text: 'Obs: Comanda 2', bold: true,  fontSize: 9 },
            ],
          ],
        },     
      },
      { text: 'Data da Abertura:        '+
        moment(dados.dataoperacao).format('DD/MM/YYYY')+      '         Por HUAN(16) Data de Fechamento:  '+
        moment(dados.dataoperacao).format('DD/MM/YYYY')+      '          por HUAN(16)', margin: [0, 5, 0, 5],  alignment: 'center', bold: true, border: [true, true, true, true], 
        fontSize: 8},
      {
          margin: [20, 25, 0, 5],
          table: {
            widths: [160, 120, 160],
            body: [
              [
                { text: 'Vendedor: CLAUDIO',  border: [false, true, false, false], bold: true, alignment: 'center',  fontSize: 9 },
                { text: '',  border: [false, false, false, false],  fontSize: 9 },
                { text: 'Cliente',  border: [false, true, false, false], bold: true, alignment: 'center',  fontSize: 9 },
              ],
            ],
          },       
      },
    ],
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default PDFPedidoClaudia;